import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import PublisherContainer from '@/components/partials/ProductTabs/Publisher/PublisherContainer';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TrackEditViewTemplateProps } from '../TrackEditViewTemplate';
import { BaseFormGroupProps } from './types';
import ReadOnlyField from '@/components/common/ReadOnlyField/ReadOnlyField';
import { IPublisher } from '@/data/models/track';

type Props = Pick<
  TrackEditViewTemplateProps,
  | 'trackData'
  | 'baseMixedTrack'
  | 'handlePublisher'
  | 'isMultipleTrack'
  | 'areNewMultipleTracks'
  | 'fieldHasErrors'
  | 'fieldValidationState'
> &
  BaseFormGroupProps;

export default function TrackPublishersFormGroup({
  trackData,
  baseMixedTrack,
  readonly,
  disabled,
  handlePublisher,
  isMultipleTrack,
  areNewMultipleTracks,
  fieldHasErrors,
  fieldValidationState,
}: Props) {
  const { t } = useTranslation();
  const [publisherTooltipKey, setPublisherTooltipKey] = useState(
    'tooltip.track.publisher'
  );

  const publishers = !isMultipleTrack
    ? trackData.publishers ?? []
    : baseMixedTrack?.publishers?.value;

  const publisherIssueField = !isMultipleTrack
    ? fieldHasErrors('Publishers')
      ? 'Publishers'
      : fieldHasErrors('Publisher')
        ? 'Publisher'
        : undefined
    : undefined;
  const validationState = publisherIssueField
    ? fieldValidationState?.(publisherIssueField)
    : undefined;
  const hasInvalidPublishers =
    !publishers ||
    publishers.length === 0 ||
    publishers.some((p: any) => {
      const pData = p?.value !== undefined ? p.value : p;
      return !pData || !pData.name || !pData.performing_Rights_Organization;
    });
  const hasErrors = !!publisherIssueField && !readonly && hasInvalidPublishers;

  return (
    <>
      {!readonly ? (
        <FormGroupWithTooltip
          tooltipKey={publisherTooltipKey}
          hasErrors={hasErrors}
        >
          <label htmlFor="publisherName-0" className="col-sm-3 form-label">
            {t('track.publisher')}
          </label>
          <div className="col-sm-6 product-publisher">
            <PublisherContainer
              errorBanner={hasErrors}
              publisher={publishers}
              originalPublisher={baseMixedTrack?.publishers?.originalValue}
              handlePublisher={handlePublisher}
              readonly={readonly}
              disabled={disabled}
              validationState={validationState}
              multiTrack={isMultipleTrack}
              showChangeIndicator={!areNewMultipleTracks}
              onFocusPublisher={() =>
                setPublisherTooltipKey('tooltip.track.publisher')
              }
              onFocusPRO={() => setPublisherTooltipKey('tooltip.track.pro')}
            />
          </div>
        </FormGroupWithTooltip>
      ) : (
        <ReadOnlyField
          id={'publisher'}
          labelTitle={t('track.publisher')}
          mode={'objectValueTypeList'}
          value={(publishers as IPublisher[])?.map((a) => ({
            name: a.name,
            role: a.performing_Rights_Organization,
          }))}
        ></ReadOnlyField>
      )}
    </>
  );
}
